<template>
    <div id="search-bar">
        <div class="search-bar-inner">
            <form action="/listings" @submit="searchForLocation">
                <div class="form-component">
                    <div class="form-group">
                        <input v-model="states.location.lat" type="hidden" name="lat">
                        <input v-model="states.location.lng" type="hidden" name="lng">
                        <address-lookup
                            :classes="['form-control', 'v2-styles', 'whitelabel-search']"
                            :disabled="states.searching"
                            :geolocate="true"
                            :value="states.location.name"
                            placeholder="Where would you like to park?"
                            name="location"
                            @input="locationNameChanged"
                            @changed="locationSelected"
                            @geolocated="locationFound"
                        />
                    </div>
                </div>
                <div class="form-component constrain">
                    <button class="btn btn-green search-button">Find Parking</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import AddressLookup from '../forms/AddressLookup';
    import GeocodeLocation from '../mixins/GeocodeLocation';

    export default {
        name: 'white-label-search',

        components: {
            AddressLookup,
        },

        mixins: [
            GeocodeLocation,
        ],

        data() {
            return {
                states: {
                    ready: false,
                    searching: false,
                    location: {
                        lat: null,
                        lng: null,
                        name: null,
                    },
                },
            };
        },

        methods: {
            /**
             * Called when the geolocation returns position.
             *
             * @param {Coordinates} coords
             */
            locationFound({ coords }) {
                this.states.location.lat = coords.latitude;
                this.states.location.lng = coords.longitude;

                this.geocodeLocation({
                    lat: coords.latitude,
                    lng: coords.longitude,
                }).then(({location}) => {
                    this.locationNameChanged(location || 'Near me');
                });
            },

            /**
             * Called when the location is selected or geolocation succeeds.
             *
             * @param {String} name
             */
            locationNameChanged(name) {
                this.states.location.name = name;
            },

            /**
             * Location was updated in the autocomplete component
             *
             * @param {Object} data
             * @param {float} lat
             * @param {float} lng
             */
            locationSelected({ lat, lng }) {
                this.states.location.lat = lat;
                this.states.location.lng = lng;
            },

            /**
             * Submit and perform the search asynchronously
             *
             * @param {Event} e
             */
            searchForLocation(e) {
                if (!(this.states.location.lat && this.states.location.lng)) {
                    e.preventDefault();
                    this.$bus.$emit('selectFirstOption');
                }
            },
        },
    };
</script>

<style lang="less" scoped>
    @import (reference) "~assets/less/variables.less";
    @import (reference) "~bootstrap/less/mixins/buttons.less";

    #search-bar {
        padding: 12px;
        border-radius: 3px;
        width: 600px;
        max-width: 96%;
        margin: 0 auto;
        position:relative;
        z-index: 1;
        .search-bar-inner {
            display: table;
            width: 100%;
        }
        form {
            display: table-row;
            .form-component {
                @media (min-width: @screen-sm-min) {
                    display: table-cell;
                    vertical-align: middle;
                    padding: 10px 5px;
                    position: relative;
                }
            }
            .constrain {
                @media (min-width: @screen-sm-min) {
                    width: 1%;
                }
            }
            .search-button {
                font-family: @headings-font-family;
                font-size: 16px;
                font-weight: 700;
                width: 100%;
                line-height: 2.4em;
                border-radius: 2px;
                min-width: 50px;
                @media (min-width: @screen-sm-min) {
                    font-size: 14px;
                    padding: 8px 24px;
                    line-height: 2.45em;
                }
                .button-variant(#ffffff, @YPS-secondary, @YPS-secondary);
            }
        }
    }
</style>

<style lang="less">
    @import (reference) "~assets/less/variables.less";

    #search-bar {
        .autocomplete-parent > a {
            opacity: 0.8;
            padding: 15px;

            @media (min-width: @screen-sm-min) {
                display: none;
            }
        }
    }
</style>
